import { render, staticRenderFns } from "./NotificationLimitedCreatorApplicationDeclined.vue?vue&type=template&id=78780967&scoped=true&"
import script from "./NotificationLimitedCreatorApplicationDeclined.vue?vue&type=script&lang=ts&"
export * from "./NotificationLimitedCreatorApplicationDeclined.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationLimitedCreatorApplicationDeclined.vue?vue&type=style&index=0&id=78780967&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78780967",
  null
  
)

export default component.exports